module.exports = __webpack_public_path__ + "templates/products-catalog.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/products/templates/products-catalog.html
// module id = 8EyY
// module chunks = 1